module.exports = __webpack_public_path__ + "img/smartcam.ed07f8c0.png";